/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @nx/enforce-module-boundaries */
import axios from 'axios';
import { logger } from '@marriott/mi-headless-utils';
import { APPLICATION_BREAKPOINTS } from '@marriott/mi-ui-library';
import { outputInterpolation, outputQuality } from '../../../constants/OfferPropertiesListConstant';
import { CA, CANADA, METERSTOKM, METERSTOMILES } from '../../../constants/CommonConstants';
import { addSubDirectoryPrefix } from '../../../utils/OfferUtils';
import { STATUS_MAX_OCCUPANCY_EXCEEDED } from '../../../constants/OfferPropertiesListConstant';
import { imgDimensionType } from '../OfferPropertiesList.types';

export const getSearchResultQuery = (
  searchData: any,
  offerId: string,
  offset: any,
  brandFacets: any,
  amentiesFacets: any,
  transportaionFacets: any,
  hotelTypeFacets: any,
  eventsFacets: any,
  activitiesFacets: any,
  isPreview: any,
  customerId: any,
  countriesFacetList: string[],
  statesFacetList: string[],
  citiesFacetList: string[],
  sortBy: string,
  marshCodes?: [],
  clusterCode?: string,
  showPricesTax?: boolean,
  includeMandatoryFees?: boolean,
  limit: number = 40
): any => {
  let obj;
  if (!isPreview) {
    obj = {
      input: {
        queries: [
          {
            id: 'offers',
            values: String(offerId),
          },
        ],
        facets: {
          terms: [
            {
              type: 'BRANDS',
              dimensions: brandFacets,
            },
            {
              type: 'AMENITIES',
              dimensions: amentiesFacets,
            },
            {
              type: 'PROPERTY_TYPES',
              dimensions: hotelTypeFacets,
            },
            {
              type: 'ACTIVITIES',
              dimensions: activitiesFacets,
            },
            {
              type: 'MEETINGS_EVENTS',
              dimensions: eventsFacets,
            },
            {
              type: 'TRANSPORTATION_TYPES',
              dimensions: transportaionFacets,
            },
          ],
        },
      },
      sort: {
        field: sortBy,
      },
      offset: offset,
      limit: limit,
      larSearch: {
        startDate: searchData?.startDate,
        endDate: searchData?.endDate,
        includeUnavailableProperties: true,
        quantity: Number(searchData?.quantity) ?? 1,
        numberInParty: Number(searchData?.numberInParty) ?? 1,
        childAges: searchData?.childAges?.map((i: string) => (Number.isNaN(Number(i)) ? 0 : Number(i))) ?? [],
        customerId: customerId,
        includeMandatoryFees: includeMandatoryFees,
        includeTaxesAndFees: showPricesTax,
      },
      limitPerCategory: 2,
    };

    interface LocationType {
      id: string;
      values: string;
    }

    if (searchData?.latitude && searchData?.longitude) {
      const locDetails: LocationType[] = [
        {
          id: 'latitude',
          values: String(searchData?.latitude),
        },
        {
          id: 'longitude',
          values: String(searchData?.longitude),
        },
      ];

      obj.input.queries.push(locDetails[0]);
      obj.input.queries.push(locDetails[1]);
    } else if (searchData?.stateCode) {
      const stateDetails = {
        id: 'state',
        values: String(searchData?.stateCode),
      };
      obj.input.queries.push(stateDetails);
    } else if (searchData?.countryCode) {
      const countryDetails = {
        id: 'country',
        values: String(searchData?.countryCode),
      };
      obj.input.queries.push(countryDetails);
    }
    // add country facets only when destination is not added
    if (!((searchData?.latitude && searchData?.longitude) || searchData?.stateCode || searchData?.countryCode)) {
      obj.input.facets.terms.push({
        type: 'COUNTRIES',
        dimensions: countriesFacetList,
      });
    }
    // add states facets
    // if (!((searchData?.latitude && searchData?.longitude) || searchData?.stateCode)) {
    obj.input.facets.terms.push({
      type: 'STATES',
      dimensions: statesFacetList,
    });
    //}
    // add city facets
    // if (!(searchData?.latitude && searchData?.longitude)) {
    obj.input.facets.terms.push({
      type: 'CITIES',
      dimensions: citiesFacetList,
    });
    // }
    if (clusterCode === '39E' || clusterCode === 'MRW' || clusterCode === 'MW1' || clusterCode === 'P17') {
      const pointsOfferReqObj = {
        ...obj,
        larSearch: {
          ...obj.larSearch,
          customerId: customerId,
          rateRequestTypes: [
            {
              type: 'CLUSTER',
              value: 'MRW',
            },
            {
              type: 'CLUSTER',
              value: 'P17',
            },
            {
              type: 'STANDARD',
              value: '',
            },
          ],
        },
      };
      return pointsOfferReqObj;
    }
  } else {
    obj = {
      search: {
        ids: marshCodes,
        options: {
          startDate: searchData?.startDate,
          endDate: searchData?.endDate,
          rateRequestTypes: [
            {
              type: 'CLUSTER',
              value: clusterCode,
            },
          ],
          includeUnavailableProperties: true,
          includeTaxesAndFees: showPricesTax,
          includeMandatoryFees: includeMandatoryFees,
          quantity: Number(searchData?.quantity) ?? 1,
          numberInParty: Number(searchData?.numberInParty) ?? 1,
        },
      },
      limit: limit,
      offset: 0,
      filter: [
        'HOTEL_MARKETING_CAPTION',
        'RESORT_FEE_DESCRIPTION',
        'DESTINATION_FEE_DESCRIPTION',
        'SURCHARGE_ORDINANCE_COST_DESCRIPTION',
      ],
      limitPerCategory: 2,
    };
    if (clusterCode === '39E' || clusterCode === 'MRW' || clusterCode === 'MW1' || clusterCode === 'P17') {
      const pointsOfferReqObj = {
        ...obj,
        search: {
          ...obj.search,
          options: {
            ...obj.search.options,
            rateRequestTypes: [
              {
                type: 'CLUSTER',
                value: 'MRW',
              },
              {
                type: 'CLUSTER',
                value: 'P17',
              },
              {
                type: 'STANDARD',
                value: '',
              },
            ],
          },
        },
      };
      return pointsOfferReqObj;
    }
  }
  return obj;
};
export const getDTTSearchResultQuery = (
  searchData: any,
  offerId: string,
  offset: any,
  brandFacets: any,
  amentiesFacets: any,
  transportaionFacets: any,
  hotelTypeFacets: any,
  eventsFacets: any,
  activitiesFacets: any,
  customerId: any,
  countriesFacetList: string[],
  statesFacetList: string[],
  citiesFacetList: string[],
  sortBy: string,
  clusterCode?: string,
  showPricesTax?: boolean,
  includeMandatoryFees?: boolean,
  limit: number = 40
): any => {
  const obj = {
    input: {
      queries: [
        {
          id: 'OFFERS',
          values: String(offerId),
        },
      ],
      facets: {
        terms: [
          {
            type: 'BRANDS',
            dimensions: brandFacets,
          },
          {
            type: 'AMENITIES',
            dimensions: amentiesFacets,
          },
          {
            type: 'PROPERTY_TYPES',
            dimensions: hotelTypeFacets,
          },
          {
            type: 'ACTIVITIES',
            dimensions: activitiesFacets,
          },
          {
            type: 'MEETINGS_EVENTS',
            dimensions: eventsFacets,
          },
          {
            type: 'TRANSPORTATION_TYPES',
            dimensions: transportaionFacets,
          },
        ],
      },
    },
    sort: {
      field: sortBy,
    },
    offset: offset,
    limit: limit,
    search: {
      options: {
        startDate: searchData?.startDate,
        endDate: searchData?.endDate,
        ...((clusterCode === '39E' || clusterCode === 'MRW' || clusterCode === 'MW1' || clusterCode === 'P17') && {
          rateRequestTypes: [
            {
              type: 'CLUSTER',
              value: 'MRW',
            },
            {
              type: 'CLUSTER',
              value: 'P17',
            },
            {
              type: 'STANDARD',
              value: '',
            },
          ],
        }),
        includeUnavailableProperties: true,
        quantity: Number(searchData?.quantity) ?? 1,
        numberInParty: Number(searchData?.numberInParty) ?? 1,
        childAges: searchData?.childAges?.map((i: string) => (Number.isNaN(Number(i)) ? 0 : Number(i))) ?? [],
        customerId: customerId,
        includeMandatoryFees: includeMandatoryFees,
        includeTaxesAndFees: showPricesTax,
      },
    },
    limitPerCategory: 2,
  };
  interface LocationType {
    id: string;
    values: string;
  }

  const params = new URLSearchParams(window.location.search);
  const hasSelectedCountry = params.has('selectedCountry');
  const isCanadaDeeplinked = hasSelectedCountry ? params.get('selectedCountry') === CANADA : false;

  if (searchData?.latitude && searchData?.longitude && !isCanadaDeeplinked) {
    const locDetails: LocationType[] = [
      {
        id: 'LATITUDE',
        values: String(searchData?.latitude),
      },
      {
        id: 'LONGITUDE',
        values: String(searchData?.longitude),
      },
    ];
    obj.input.queries.push(locDetails[0]);
    obj.input.queries.push(locDetails[1]);
  } else if (searchData?.stateCode) {
    const stateDetails = {
      id: 'STATE',
      values:
        isCanadaDeeplinked && searchData?.countryCode === CA
          ? `${String(searchData?.countryCode)}-${searchData?.stateCode}`
          : String(searchData?.stateCode),
    };
    obj.input.queries.push(stateDetails);
  } else if (searchData?.countryCode) {
    const countryDetails = {
      id: 'COUNTRY',
      values: String(searchData?.countryCode),
    };
    obj.input.queries.push(countryDetails);
  }
  // add country facets only when destination is not added
  if (!((searchData?.latitude && searchData?.longitude) || searchData?.stateCode || searchData?.countryCode)) {
    obj.input.facets.terms.push({
      type: 'COUNTRIES',
      dimensions: countriesFacetList,
    });
  }
  // add states facets
  obj.input.facets.terms.push({
    type: 'STATES',
    dimensions: statesFacetList,
  });
  // add city facets
  obj.input.facets.terms.push({
    type: 'CITIES',
    dimensions: citiesFacetList,
  });
  return obj;
};

export const getCommaSeparator = (numb: number, lang: string) => {
  return numb ? Number(Math.floor(numb))?.toLocaleString(lang || '') : null;
};

export const updateSessionObj = async (ariesOffer: any = {}) => {
  const sessionToken = typeof window !== 'undefined' ? window?.sessionData?.sessionToken : '';
  const currentOfferId = window?.location?.pathname ? window?.location?.pathname?.split('/').pop() : '';

  try {
    const url = '/mi/phoenix-gateway/session';
    const headers = {
      Cookie: `sessionID=${sessionToken}`,
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
    };
    const payload = {
      createOrUpdate: {
        AriesOffer: { ...ariesOffer, AriesOfferId: currentOfferId },
      },
      remove: [],
      sessionToken: sessionToken,
    };
    await axios
      .patch(url, payload, {
        headers: headers,
      })
      .then((res: any) => {
        return res?.status;
      });
  } catch (error) {
    console.log(`OffersPropertiesList update session API Failed:, ${error}`); // eslint-disable-line no-console
  }
};

export const formatNumberByLocale = (numb: number | string, lang: string): string => {
  const { log } = logger({})('formatNumberByLocale');
  log.debug(
    `[PerfTesting][utils] Entering the formatNumberByLocale lang:${lang} function at time: ${new Date().getHours()} ${new Date().getMinutes()} ${new Date().getSeconds()} ${new Date().getMilliseconds()}`
  );
  const inputStr = numb ?? '';
  // convert input number to locale string according to the lang
  // const str = Number(inputStr).toLocaleString(lang || '');
  let str = '';
  switch (lang) {
    case 'ko-KR':
    case 'ja-JP':
    case 'it-IT':
    case 'fr-FR':
    case 'de-DE':
    case 'ru-RU':
      str = Number(inputStr)?.toLocaleString(lang || '', { maximumFractionDigits: 2 });
      break;
    case 'pt-BR':
      str = Number(inputStr)?.toLocaleString(lang || '', { maximumFractionDigits: 3 });
      break;
    case 'es-ES':
      str = Number(inputStr)?.toLocaleString(lang || '', { maximumFractionDigits: 2, useGrouping: true });
      break;
    case '':
    case undefined:
      str = Number(inputStr)?.toLocaleString();
      break;
    default:
      str = Number(inputStr)?.toLocaleString(lang || '');
      break;
  }
  log.debug(
    `[PerfTesting][utils] Exiting the formatNumberByLocale lang:${lang} function at time: ${new Date().getHours()} ${new Date().getMinutes()} ${new Date().getSeconds()} ${new Date().getMilliseconds()}`
  );
  return str;
};
export function getCalculatedDistance(dist: number | undefined, km: boolean, lang?: string): string | null {
  /** calculated distance for km/ miles */
  if (dist) {
    if (km) {
      // convert meters to km
      return formatNumberByLocale((dist / METERSTOKM).toFixed(1), lang || '');
    } else {
      // convert meters to miles
      return formatNumberByLocale((dist / METERSTOMILES).toFixed(1), lang || '');
    }
  }
  return null;
}

export const getDeepLinkFilters = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const deepLinkFilters: Record<string, [string]> = {};
  for (const [key, value] of urlParams.entries()) {
    deepLinkFilters[key] = [value];
  }
  return deepLinkFilters;
};
export const getControlsData = (currentFilterData: any) => {
  const desiredKeys = ['code', 'count', 'label', 'description'];
  const updatedFilterOptions = currentFilterData?.map((obj: any) => {
    const newFilterOptionsObj: any = {};
    desiredKeys?.forEach(key => {
      newFilterOptionsObj[key] = obj[key];
    });
    const modifiedLabel = obj?.label ?? obj?.description ?? obj?.code;
    return { ...newFilterOptionsObj, label: modifiedLabel };
  });
  return updatedFilterOptions;
};

export const findWarningIndex = (response: any, code: string | number): number => {
  const warnings = response?.status?.[0]?.warnings;
  if (!Array.isArray(warnings)) {
    return -1;
  }
  const index = warnings.findIndex((warning: any) => warning?.code === code);
  return index;
};

export const constructAdfOrRlmURL = (
  availabilitySearchURL: string,
  navigationADFURL: string,
  navigationRLMURL: string,
  isFlexibleDateSearch: boolean,
  propertyID: string,
  currentCurrency: string,
  includeTaxesAndFees: boolean,
  searchData?: any,
  fromDate?: string,
  toDate?: string,
  clusterCode?: string
) => {
  const guestParams = searchData
    ? `&numberOfRooms=${searchData?.quantity}` +
      `&numberOfAdults=${Number(searchData?.numberInParty) - (searchData?.childAges?.length ?? 0)}` +
      `&childrenCount=${searchData?.childAges?.length ?? ''}` +
      `&childrenAges=${
        searchData?.childAges?.length ? searchData.childAges.map((i: any) => (Number.isNaN(Number(i)) ? '0' : i)) : ''
      }`
    : '';

  const dateParams = fromDate && toDate ? `&fromDate=${fromDate}&toDate=${toDate}` : '';

  const clusterParams =
    clusterCode != null ? `&corporateCode=${clusterCode}&clusterCode=${clusterCode === '0' ? 'none' : 'corp'}` : '';

  const baseUrl = isFlexibleDateSearch
    ? addSubDirectoryPrefix(`${availabilitySearchURL}${navigationADFURL}`) + propertyID + '&isSearch=true&currency='
    : addSubDirectoryPrefix(`${availabilitySearchURL}${navigationRLMURL}`) +
      propertyID +
      '&isSearch=true&currency=' +
      (currentCurrency === '' ? '' : currentCurrency) +
      '&showFullPrice=' +
      includeTaxesAndFees +
      (currentCurrency === '' ? '' : '&redirectedFromSERP=true');

  return baseUrl + guestParams + dateParams + clusterParams;
};

//function to determine if hotel is unavailable or max occupied
export const hotelUnavailableOrMaxOccupied = (
  rateNode: any,
  pointsRateBlock: any,
  eeoRateBlock: any,
  isFlexibleDateSearch: boolean,
  openingDate: any
) => {
  let isHotelMaxOccupancyExceeded = false;
  let isHotelUnavailable = false;

  if (
    !isFlexibleDateSearch &&
    (rateNode?.status?.code === STATUS_MAX_OCCUPANCY_EXCEEDED ||
      pointsRateBlock?.status?.code === STATUS_MAX_OCCUPANCY_EXCEEDED ||
      eeoRateBlock?.status?.code === STATUS_MAX_OCCUPANCY_EXCEEDED)
  ) {
    isHotelMaxOccupancyExceeded = true;
  } else if (
    !isFlexibleDateSearch &&
    !(rateNode?.rateModes?.lowestAverageRate?.amount || pointsRateBlock?.rateModes?.pointsPerUnit?.points) &&
    openingDate
  ) {
    isHotelUnavailable = true;
  }
  return { isHotelMaxOccupancyExceeded, isHotelUnavailable };
};

// Utility to compare arrays of objects (shallow)
export const isEqualArray = (a: any[] = [], b: any[] = []) =>
  a.length === b.length && a.every((v, i) => JSON.stringify(v) === JSON.stringify(b[i]));

export const isOnlyCurrencyChanged = (prevFilters: any, newFilters: any): boolean => {
  const filterKeys = [
    'selectedBrands',
    'selectedAmenities',
    'selectedTransportation',
    'selectedHotelType',
    'selectedEvents',
    'selectedActivities',
    'selectedCountries',
    'selectedStates',
    'selectedCities',
  ];
  const areAllFiltersEqual = filterKeys.every(key => isEqualArray(prevFilters[key], newFilters[key]));
  return (
    areAllFiltersEqual &&
    prevFilters.isTaxSliderActive === newFilters.isTaxSliderActive &&
    !isEqualArray(prevFilters.selectedCurrency, newFilters.selectedCurrency)
  );
};

//pagination
export const getInitialPageAndOffset = (paramName: string, propertiesPerPage: number) => {
  if (typeof window !== 'undefined') {
    const url = new URL(window.location.href);
    const pageNo = url.searchParams.get(paramName);
    const page = parseInt(pageNo || '1', 10);
    const offset = (page - 1) * propertiesPerPage;
    return { page, offset };
  }
  return { page: 1, offset: 0 };
};

//image helpers
export const getImageSetup = (width: number): imgDimensionType => {
  let imageDimensions = {
    height: 288,
    width: 512,
  };
  if (Number(width) < APPLICATION_BREAKPOINTS['viewportL']) {
    imageDimensions = {
      height: 240,
      width: 360,
    };
  }
  if (Number(width) > APPLICATION_BREAKPOINTS['viewportL'] || Number(width) < APPLICATION_BREAKPOINTS['viewportS']) {
    imageDimensions = {
      height: 222,
      width: 715,
    };
  }
  return imageDimensions;
};

export const getImageProps = (width: number | undefined): string => {
  const imageDimensions = getImageSetup(width ?? 0);
  const imgProp =
    `?output-quality=${outputQuality}&interpolation=${outputInterpolation};*,*&downsize=` +
    imageDimensions.width +
    'px:*';
  return imgProp;
};

/**
 * Applies param updates to a URL string and returns the updated relative URL.
 * Pass a string value to set a param, or null to delete it.
 */
const applyUrlParams = (url: string, updates: Record<string, string | null>): string => {
  try {
    const absolute = new URL(url, window.location.origin);
    for (const [key, value] of Object.entries(updates)) {
      value === null ? absolute.searchParams.delete(key) : absolute.searchParams.set(key, value);
    }
    return `${absolute.pathname}${absolute.search || ''}${absolute.hash || ''}`;
  } catch {
    const [base, hashPart] = url.split('#');
    const hash = hashPart ? `#${hashPart}` : '';
    const [path, qs] = base.split('?');
    const params = new URLSearchParams(qs || '');
    for (const [key, value] of Object.entries(updates)) {
      value === null ? params.delete(key) : params.set(key, value);
    }
    const newQuery = params.toString();
    return `${path}${newQuery ? `?${newQuery}` : ''}${hash}`;
  }
};

export const updateHrefCurrency = (href: string, currencyCode?: string): string => {
  return applyUrlParams(href, {
    currency: currencyCode?.trim() || '',
  });
};

export const updateAdfRlmUrlCurrency = (url: string, currencyCode?: string, showPricesTax?: boolean): string => {
  const hasCurrency = !!(currencyCode && currencyCode.trim().length > 0);
  return applyUrlParams(url, {
    currency: hasCurrency ? currencyCode.trim() : '',
    redirectedFromSERP: hasCurrency ? 'true' : null,
    showFullPrice: String(showPricesTax ?? false),
  });
};

export const updateHotelsCurrencyInFooterLinks = <
  T extends { footerLinkDetails?: { href?: string; ADFRLMratePage?: string } }
>(
  hotels: T[],
  currencyCode?: string,
  showPricesTax?: boolean
): T[] => {
  if (!Array.isArray(hotels) || hotels.length === 0) return hotels ?? [];

  return hotels.map(hotel => {
    const oldHref = hotel?.footerLinkDetails?.href;
    if (!oldHref || typeof oldHref !== 'string') return hotel;

    return {
      ...hotel,
      footerLinkDetails: {
        ...(hotel.footerLinkDetails ?? {}),
        href: updateHrefCurrency(oldHref, currencyCode),
        ...(hotel.footerLinkDetails?.ADFRLMratePage
          ? {
              ADFRLMratePage: updateAdfRlmUrlCurrency(
                hotel.footerLinkDetails.ADFRLMratePage,
                currencyCode,
                showPricesTax
              ),
            }
          : {}),
      },
    };
  });
};

export const getCurrencyList = (hotels: any): string[] => {
  const currList: string[] = [];
  hotels?.forEach((hotel: any) => {
    const currency = hotel?.footerLinkDetails?.currency;
    if (currency && !currList?.includes(currency)) {
      currList.push(currency);
    }
  });
  return currList;
};

export const calculateCurrencyConversionRate = (currencyConversionData: any) => {
  if (
    currencyConversionData?.exchangeRateByCurrencyCodes?.outputCurrencyExchangeRate &&
    currencyConversionData.exchangeRateByCurrencyCodes?.outputCurrencyDecimalPoint
  ) {
    const conversionRate =
      currencyConversionData.exchangeRateByCurrencyCodes?.outputCurrencyExchangeRate /
      Math.pow(10, currencyConversionData.exchangeRateByCurrencyCodes.outputCurrencyDecimalPoint);
    return conversionRate;
  } else return null;
};
